/* global BX, initCountdown, setBasketStatusBtn, InitFlexSlider, InitZoomPict, initCalculatePreview, showTotalSummItem */

(function () {
    class FastViewModal {
        constructor() {
            this.modal = null;
            this.overlay = null;
            this.isLoading = false;
            this.init();
        }

        init() {
            // document.addEventListener('click', (e) => {
            //     const trigger = e.target.closest('[data-param-form_id="fast_view"], .fast_view_block');
            //     if (!trigger) return;
            //     const formId = trigger.getAttribute('data-param-form_id');
            //     if (formId !== 'fast_view') return;
            //     e.preventDefault();
            //     this.open(trigger);
            // });
            //
            // document.addEventListener('keydown', (e) => {
            //     if (e.key === 'Escape') this.close();
            // });
        }

        async open(trigger) {
            if (this.isLoading) return;
            this.isLoading = true;

            let itemHref = trigger.getAttribute('data-param-item_href');
            if (!itemHref) {
                console.error('FastViewModal: Missing item href');
                this.isLoading = false;
                return;
            }

            try {
                itemHref = decodeURIComponent(itemHref);
            } catch (e) {
                console.error('FastViewModal: decodeURIComponent error', e);
            }

            try {
                const modalHtml = await fetch('/ajax/fast_view.php', {
                    method: 'GET',
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                }).then((response) => response.text());

                this.render(modalHtml);

                const separator = itemHref.includes('?') ? '&' : '?';
                const productUrl = itemHref + separator + 'FAST_VIEW=Y';

                const productHtml = await fetch(productUrl, {
                    method: 'GET',
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                }).then((response) => response.text());

                const processed = BX.processHTML(productHtml);
                const container = this.modal.querySelector('#fast_view_item');
                if (container) {
                    container.innerHTML = processed.HTML;
                }

                BX.ajax.processScripts(processed.SCRIPT);
                this.initProductFunctions();

                const hiddenTitle = this.modal.querySelector('.title.hidden');
                const modalTitle = this.modal.querySelector('.form_head h2');
                if (hiddenTitle && modalTitle) {
                    modalTitle.innerHTML = hiddenTitle.innerHTML;
                }
            } catch (e) {
                console.error('FastViewModal: fetch or render error', e);
            } finally {
                this.isLoading = false;
            }
        }

        render(html) {
            this.close();

            this.overlay = document.createElement('div');
            this.overlay.className = 'jqmOverlay';
            this.overlay.addEventListener('click', () => this.close());

            this.modal = document.createElement('div');
            this.modal.className = 'fast_view_frame jqmWindow popup';
            this.modal.innerHTML = html;

            document.body.appendChild(this.overlay);
            document.body.appendChild(this.modal);

            const closeBtn = this.modal.querySelector('.jqmClose');
            if (closeBtn) {
                closeBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.close();
                });
            }
        }

        initProductFunctions() {
            if (typeof initCountdown === 'function') initCountdown();
            if (typeof setBasketStatusBtn === 'function') setBasketStatusBtn();
            if (typeof InitFlexSlider === 'function') InitFlexSlider();
            if (typeof InitZoomPict === 'function') {
                const zoomPicture = this.modal.querySelector('.zoom_picture');
                if (zoomPicture) InitZoomPict(zoomPicture);
            }
            if (typeof initCalculatePreview === 'function' && this.modal.querySelector('.item_main_info.noffer')) {
                initCalculatePreview();
            }
            if (typeof showTotalSummItem === 'function') {
                setTimeout(() => showTotalSummItem('Y'), 100);
            }
            window.dispatchEvent(new Event('scroll'));
        }

        close() {
            if (this.modal) this.modal.remove();
            if (this.overlay) this.overlay.remove();
            this.modal = null;
            this.overlay = null;
        }
    }

    new FastViewModal();
})();
